module.exports = __webpack_public_path__ + "img/google-stadia-03.4807cdb9.webp";